module.exports = __webpack_public_path__ + "media/images/athletes/2351-126fdc8f1bee7ff78db27e012800823b.png";